import { render, staticRenderFns } from "./ConnectionAssignmentsDialog.vue?vue&type=template&id=822cbbb4&scoped=true"
import script from "./ConnectionAssignmentsDialog.vue?vue&type=script&lang=ts"
export * from "./ConnectionAssignmentsDialog.vue?vue&type=script&lang=ts"
import style0 from "./ConnectionAssignmentsDialog.vue?vue&type=style&index=0&id=822cbbb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822cbbb4",
  null
  
)

export default component.exports